import React from "react";

import { BlockView } from "common/views/block/BlockView.view";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel, PanelActions } from "core/decorators/Panel";
import CESelfReportFormPanelConfig from "./CESelfReportFormConfig";
import * as displayFragments from "./displayFragments"
import * as actionFragments from "./actionFragments"

export interface Entry{
	name?: string,
	startDate?: string,
	endDate?: string,
	year?:string,
	description?:string,
	credits?:[],
	uploadCertificate?: File[],
	subscriptionId?: string
}

export class ICESelfReportFragmetProps{
    entry:Entry
    onChange: (name:string, value:string|File|any) => void;
	config: CESelfReportFormPanelConfig;
	actions:PanelActions<any>
}

export interface IState{
    entry:Entry;
}

const fragments = {
    ...displayFragments,
	...actionFragments
};

@Panel({
	id: "addExternalPanel",
	configClass: CESelfReportFormPanelConfig,
	pageParams: true
})
export default class CESelfReportFormPanel extends React.Component<
	IPanelProps<CESelfReportFormPanelConfig>,
	IState
> {
	constructor(props: IPanelProps<CESelfReportFormPanelConfig>) {
		super(props);

		// Initialize entry from pageParams if available (for edit mode)
		let initialEntry: Entry = {};
		if (props.pageParams && props.pageParams.entry) {
			try {
				initialEntry = JSON.parse(props.pageParams.entry);
			} catch (e) {
				console.error('Error parsing entry from pageParams:', e);
			}
		}

		this.state = {
			entry: initialEntry
		};
	}

	handleInputChange = (name: string, value: string|File|any) => {
		this.setState(preState => {
			let entry = preState.entry;
			entry[name] = value;

			return {
				...preState,
				entry: entry
			};
		});
	};

	public render() {
		const { config, actions } = this.props;

		return (
			<BlockView
				key="CESelfReportFormPanel"
				viewKey="CESelfReportFormPanel"
			>
				<FragmentLayout
					fragments={fragments}
					layout={config.layout}
					props={{
						onChange: this.handleInputChange,
                        entry: this.state.entry,
						config,
						actions
					}}
				/>
			</BlockView>
		);
	}
}


// WEBPACK FOOTER //
// ./src/panels/addExternalCredit/CESelfReportForm.panel.tsx